// src/components/StudentReceipt.js
import React, {useEffect} from 'react';
import '../../../css/ack.css';
import styles from '../../../css/Acknowledgement.module.css'
import Barcode from 'react-barcode';
import { useDispatch, useSelector } from 'react-redux';
import { readSchools } from '../../../store/actions/schoolActions';
import { fetchLogo  } from '../../../store/actions/logoActions';
import './globalStyles.css';


const Acknowledgement = React.forwardRef(({ data }, ref) => {

  const dispatch = useDispatch();
  const { schools } = useSelector((state) => state.schoolDetails);
  const { logoUrl } = useSelector((state) => state.logo);

  useEffect(() => {
    dispatch(readSchools());
  }, [dispatch]);

  // Fetch the logo on component mount
  useEffect(() => {
    dispatch(fetchLogo());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (logoUrl) {
        URL.revokeObjectURL(logoUrl);
      }
    };
  }, [logoUrl]);

  const imageUrl = logoUrl;
  const barcodeImage = <Barcode value={data.student_uid} width={0.97} height={35} />; 

  
  return (
    <>
   {logoUrl && <img src={logoUrl} alt="SCHOOL_LOGO" style={{ maxWidth: '100px' }} />}
    <div className={styles.Acknowledgement} ref={ref}>
          <div className={styles.page}>
            <div className='d-flex justify-content-between align-item-center'>
              <div className='d-flex justify-content-centre align-item-center mt-1'>
                {/* <img className='m-2' src={logoUrl} alt="SCHOOL_LOGO" width={50} /> */}
                
                <div>
                    {logoUrl ? (
                      <img
                        src={logoUrl}
                        alt="School Logo"
                        style={{ maxWidth: '100px' }}
                        onError={(e) => {
                          e.target.onerror = null; // Prevents looping
                          e.target.src = '/path/to/placeholder/image.png'; // Placeholder image path
                        }}
                      />
                    ) : (
                      <p>Loading logo...</p>
                    )}
                  </div>


              </div>
              <div className='tile'>
                {schools && schools.length > 0 ? (
                    schools.map((school, index) => (
                      <div key={index}>
                        <h3><span style={{color: '#003366'}}><strong> {school.school_name} </strong></span></h3>
                        <p>
                        <span style={{color: '#003366'}}>
                          {school.city}, {school.district}, {school.state}, {school.postal_code}<br />
                          <strong>Contact: {school.contact_number}</strong>
                        </span>                          
                        </p>
                      </div>
                    ))
                  ) : (
                    <>
                      <h3><span style={{color: '#003366'}}><strong>School Name</strong></span></h3>
                        <p>
                          <span style={{color: '#003366'}}>
                            <strong>Address</strong><br />
                            <strong>Contact: +91-xxxxx-xxxxx</strong>
                          </span>
                        </p>
                    </>
                  )}
                
              </div>
              <div className="d-flex justify-content-end m-2">
                <p className='text-danger'>Serial No.: {data.student_id}</p>
              </div>
            </div>
            <table  style={{height: '230px', border: '1.2px solid black'}}  width={967}>
              <tbody>
                <tr style={{height: '21px', border: '1.2px solid black'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}><strong>Student UID</strong></td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}><strong>{data.student_uid}</strong></td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px', textAlign: 'center'}} colspan={2}>{barcodeImage}<br /><br /></td>
                <td style={{width: '500.25px', border: '1.2px solid black', height: '21px', textAlign: 'center'}} rowspan={3}>
                  <img src={data.pass_photo} alt="Student" width={100} />
                  <br /><br /></td>
                </tr>
                <tr style={{height: '27.9px'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '27.9px'}}>Admission No:</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '27.9px'}}>{data.student_id}</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '27.9px'}}>Date:</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '27.9px'}}>{data.admitted_on}</td>
                </tr>
                <tr style={{height: '21px'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Full Name</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>{data.full_name}</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Date of Birth</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>{data.dob}</td>
                </tr>
                <tr style={{height: '21px'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Gender</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>&nbsp;{data.sex}</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Nationality</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}} colspan={2}>Indian&nbsp;</td>
                </tr>
                <tr style={{height: '21px'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Father's name</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>&nbsp;{data.father_name}</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Mother's name</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}} colspan={2}>&nbsp;{data.mother_name}</td>
                </tr>
                <tr style={{height: '21px'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Guardian's Name</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>&nbsp;{data.guardian_name}</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Riligion</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}} colspan={2}>&nbsp;Christian</td>
                </tr>
                <tr style={{height: '21px'}}>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Contact 1</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>&nbsp;{data.contact_no}</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Contact 2</td>
                <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}} colspan={2}>&nbsp;</td>
                </tr>
                <tr style={{height: '21px'}}>
                    <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}}>Address for communication:</td>
                    <td style={{width: '235.25px', border: '1.2px solid black', height: '21px'}} colspan={4}>&nbsp;{data.r_address}</td>
                </tr>
              </tbody>
            </table>
            <div className={styles.cuttingLine}>
              <span className={styles.scissors}>✂️</span>
            </div>
            <p style={{textAlign: 'center', marginTop:'50px'}}>&nbsp;</p>
            <div className='d-flex justify-content-between align-item-center mt-40'>
              <div className='d-flex justify-content-centre align-item-center'>
                <p>Office use</p>
              </div>
              <div className='tile'>
              {schools && schools.length > 0 
              ? (
                    schools.map((school, index) => (
                      <div key={index}>
                        <h3><span style={{color: '#003366'}}><strong> {school.school_name} </strong></span></h3>
                      </div>
                    ))
                  ) 
                  : 'For School Name'
                }
              </div>
              <div className="d-flex justify-content-end m-2">
                <p className='text-danger'>Serial No.: {data.student_id}</p>
              </div>
            </div>
            <table style={{height: '154px', borderColor: 'black'}} width={1031}>
            <tbody>
            <tr>
            <td style={{width: '251.25px', backgroundColor: '#f7c522'}} colspan="5"><span style={{color: '#000000'}}>Student Details</span></td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Full Name</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.full_name}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Registration No.</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.student_uid}</td>
            <td style={{width: '251.25px', border: '1px solid black'}} rowspan="3">
              <img src={data.pass_photo} alt="Student" width={100} />
            </td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Gender</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.sex}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Admission No.</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.student_id}</td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Date of Birth</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.dob}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Admission Date</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.admitted_on}</td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Admitted to class</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.class_admitted}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Academic Session</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{2024}</td>
            <td style={{width: '251.25px', textAlign: 'center'}}>{barcodeImage}</td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Father's Name</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.father_name}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Mother's Name</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.mother_name}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>State</td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Contact No. 1</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.contact_no}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Contact No. 2</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>{data.contact_no}</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>State</td>
            </tr>
            <tr>
            <td style={{width: '251.25px', border: '1px solid black'}}>Address for Communication</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>36</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Maikhuli</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>Ri-Bhoi</td>
            <td style={{width: '251.25px', border: '1px solid black'}}>793101</td>
            </tr>
            </tbody>
            </table>
            <p>&nbsp;</p> 
          </div>
    </div>
    </>
  );
});


export default Acknowledgement
